const { configByLanguage } = require('./configBy');

const getBaseConfig = (hostConfig, rawConfig, langcode) => {
  // Load required raw data.
  const ngMaster = rawConfig['config/natgeo_master'];
  const rawMetadataDefaults = rawConfig['custom/metadata_defaults'];

  // Create several variables used across config creation.
  const isStage = ngMaster.is_stage || false;
  const siteCountryCode = configByLanguage[langcode].country;
  const canonicalDomain = configByLanguage[langcode].domain;
  const stageDomain = `cms-stage-${siteCountryCode}.ngeo.com`;

  const config = {
    hash: rawConfig.hash,
    langcode,
    langcodeIso639_1: langcode.substring(0, 2),
    tagManagerContainerID:
      rawConfig['config_pages/google_tag_manager'].containerId,
    isStage,
    siteName: rawConfig['config/system.site'].name,
    siteCountryCode,
    localDrupalDevDomain: `${siteCountryCode}.ngeo.local`,
    canonicalDomain,
    stageDomain,
    currentDomain: isStage ? stageDomain : canonicalDomain,
    staticDomain: configByLanguage[langcode].static.prod,
    s3Bucket: `fng-globalsites-${
      isStage ? 'stage' : 'prod'
    }-html-current-${siteCountryCode}.s3.eu-central-1.amazonaws.com`,
    s3BucketPublicDomain: isStage
      ? configByLanguage[langcode].html.stage
      : canonicalDomain,
    s3BucketId: `fng-globalsites-${
      isStage ? 'stage' : 'prod'
    }-html-current-${siteCountryCode}`,
    searchEndpoint: isStage
      ? `https://${configByLanguage[langcode].search.stage}.execute-api.eu-central-1.amazonaws.com/stage/pluto`
      : `https://${canonicalDomain}/api-pluto/pluto`,
    searchEndpointApiKeyStage: isStage
      ? '1pVLSU09lf8F3yW6WBYO11FHATzXWeE97eKj7GnY'
      : undefined,
    weekStartDay: configByLanguage[langcode].weekStartDay,
    oneTrust: configByLanguage[langcode].oneTrust,
    gamAccountId: isStage ? '21743558653' : '21783347309',
    facebookDomainVerification:
      configByLanguage[langcode].facebookDomainVerification,
    defaultTimeZone: rawConfig['config/system.date'].timezone.default,

    // NatGeo Master Settings.
    age_verification: ngMaster.age_verification,
    primetime_start_hour: ngMaster.primetime_start_hour,
    primetime_start_minute: ngMaster.primetime_start_minute,
    primetime_end_hour: ngMaster.primetime_end_hour,
    primetime_end_minute: ngMaster.primetime_end_minute,
    upcoming_episodes_offset: ngMaster.upcoming_episodes_offset,
    display_full_schedule_button: ngMaster.display_full_schedule_button,
    full_schedule_button_link: ngMaster.full_schedule_button_link,
    sponsoredDefaultAdditionalText: ngMaster.default_sponsored_text || '',
    sponsoredTravellerAdditionalText: ngMaster.traveller_sponsored_text || '',
    ad_refresh_rate: ngMaster.ad_refresh_rate || 0,
    sweepstakes_js_url: ngMaster.sweepstakes_js_url,
    activate_cmp: ngMaster.activate_cmp || false,

    // TV settings.
    tvSettings: rawConfig['config/natgeo_tv'],

    // Video.
    videoPlayerTemplate:
      rawConfig['config/natgeo_video']?.video_player_template ||
      'ngpgs/default',

    // Newsletter.
    newsletter: rawConfig['config/natgeo_newsletter'],

    // Cookie Policy.
    cookiePolicy: rawConfig['config_pages/cookie_policy_footer'],

    // Metadata defaults.
    metadataDefaults: {
      fb_app_id: rawMetadataDefaults.fb_app_id,
      article_author: rawMetadataDefaults.article_author,
      twitter_cards_creator: rawMetadataDefaults.twitter_cards_creator,
      twitter_cards_site: rawMetadataDefaults.twitter_cards_site
    },

    transporterSettings: rawConfig['config/natgeo_transporter'],

    ptt: rawConfig['custom/ptt']
  };

  // Add conditional custom code settings.
  if (ngMaster.active_code_custom) {
    config.active_code_custom = ngMaster.active_code_custom;
    config.bundle_code_custom_css = ngMaster.bundle_code_custom_css;
    config.bundle_code_custom_js = ngMaster.bundle_code_custom_js;
    config.header_code_custom = ngMaster.header_code_custom;
    config.footer_code_custom_html = ngMaster.footer_code_custom_html;
  }

  // Add conditional CMP settings.
  if (config.activate_cmp) {
    config.iab_compliance = ngMaster.iab_compliance || false;
    config.cmp_js_url = ngMaster.cmp_js_url || undefined;
    config.cmp_js_data_domain_script = hostConfig.isPreview
      ? ngMaster[
          `cmp_js_data_domain_script_cms_domain_${isStage ? 'stage' : 'prod'}`
        ]
      : ngMaster[`cmp_js_data_domain_script_${isStage ? 'stage' : 'prod'}`];
    config.cmp_group_functionalities =
      ngMaster.cmp_group_functionalities || 'fc';
    config.cmp_group_targeting = ngMaster.cmp_group_targeting || 'tg';
    config.cmp_group_social_media = ngMaster.cmp_group_social_media || 'sm';
    config.cmp_group_performance = ngMaster.cmp_group_performance || 'pc';
  }

  return config;
};

const getMenus = rawConfig => {
  const menus = {
    menuGlobalNavigation: rawConfig['menu/natgeo-global-nav'],
    menuMainNavigation: rawConfig['menu/main'],
    menuContent: rawConfig['menu/content'],
    menuSubscribeHeader: rawConfig['menu/subscribe-header'],
    menuSections: rawConfig['menu/sections'],
    menuFooter: rawConfig['menu/footer'],
    menuFooterExplore: rawConfig['menu/explore'],
    menuFooterAboutUs: rawConfig['menu/about-us'],
    menuFooterSubscribe: rawConfig['menu/subscribe'],
    menuSocialMedia: rawConfig['config_pages/social_media']
  };

  return menus;
};

const processConfig = (hostConfig, rawConfig, langcode) => {
  return {
    ...hostConfig,
    ...getBaseConfig(hostConfig, rawConfig, langcode),
    menus: getMenus(rawConfig),
    locale: rawConfig['locale/locale']
  };
};

module.exports = { processConfig };
